import { render } from "./booking-confirm.vue?vue&type=template&id=522ea446"
import script from "./booking-confirm.vue?vue&type=script&lang=js"
export * from "./booking-confirm.vue?vue&type=script&lang=js"

import "./booking-confirm.vue?vue&type=style&index=0&id=522ea446&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__